import React, { useEffect, useState } from "react";

const API =
  process.env.NODE_ENV === "production"
    ? "https://ecovanta.onrender.com"
    : "http://localhost:5000";

export default function ESGMaturityAssessmentHistory() {
  const [assessments, setAssessments] = useState([]);
  const [status, setStatus] = useState("Loading assessment history...");

  useEffect(() => {
    async function loadAssessments() {
      try {
        const response = await fetch(`${API}/maturity-assessments`);
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data?.error || "Unable to load assessments.");
        }

        setAssessments(Array.isArray(data) ? data : []);
        setStatus("");
      } catch (error) {
        console.error("Load assessments failed:", error);
        setStatus(`Failed to load assessments: ${error.message}`);
      }
    }

    loadAssessments();
  }, []);

  return (
    <main
      style={{
        maxWidth: "1100px",
        margin: "0 auto",
        padding: "40px 20px"
      }}
    >
      <h1>My ESG Assessments</h1>

      <p>
        Review saved ESG Maturity Benchmark results and track maturity progress
        over time.
      </p>

      <div
        style={{
          display: "flex",
          gap: "12px",
          marginBottom: "24px",
          flexWrap: "wrap"
        }}
      >
        <a
          href="/esg-maturity-benchmark"
          style={{
            padding: "12px 20px",
            borderRadius: "8px",
            background: "#0f766e",
            color: "#ffffff",
            textDecoration: "none",
            fontWeight: 600
          }}
        >
          Start New Assessment
        </a>
      </div>

      {status && <p>{status}</p>}

      {!status && assessments.length === 0 && (
        <p>No saved assessments yet.</p>
      )}

      {assessments.length > 0 && (
        <table
          style={{
            width: "100%",
            marginTop: "24px",
            borderCollapse: "collapse"
          }}
        >
          <thead>
            <tr
              style={{
                borderBottom: "2px solid #e5e7eb"
              }}
            >
              <th align="left" style={{ padding: "12px" }}>
                Date
              </th>

              <th align="left" style={{ padding: "12px" }}>
                Score
              </th>

              <th align="left" style={{ padding: "12px" }}>
                Maturity Level
              </th>

              <th align="left" style={{ padding: "12px" }}>
                Top Priority
              </th>

              <th align="left" style={{ padding: "12px" }}>
                Actions
              </th>
            </tr>
          </thead>

          <tbody>
            {assessments.map((assessment) => {
              const topPriority =
                assessment.recommendations?.[0];

              return (
                <tr
                  key={assessment._id}
                  style={{
                    borderBottom: "1px solid #e5e7eb"
                  }}
                >
                  <td style={{ padding: "12px" }}>
                    {new Date(
                      assessment.createdAt
                    ).toLocaleDateString()}
                  </td>

                  <td style={{ padding: "12px" }}>
                    {assessment.overallScore}/5
                  </td>

                  <td style={{ padding: "12px" }}>
                    {assessment.maturityLevel}
                  </td>

                  <td style={{ padding: "12px" }}>
                    {topPriority?.name || "N/A"}
                  </td>

                  <td style={{ padding: "12px" }}>
                    <a
                      href={`/esg-maturity-history/${assessment._id}`}
                      style={{
                        color: "#0f766e",
                        fontWeight: 600,
                        textDecoration: "none"
                      }}
                    >
                      View Report
                    </a>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </main>
  );
}